// based on rc-pagination 1.17.8
export { default } from './Pagination';
